export default __webpack_public_path__ + "aad6db5a0fc5b60110ea3f130a9cc631.png";